// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1__Mx","cls2":"AutoCompleteResultRow-cls2_kWD AutoCompleteResultRow-cls1__Mx"};